const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "International Islamic University Chittagong (2017 - 2022)",
    title: "BSc in Electrical and Electronic Engineering",
    desc: "I have a great wish to study in Engineering Subject. I could complete it from International Islamic University Chittagong (IIUC) with a great result",
    rate: "3.74/4",
  },
  {
    id: 2,
    category: "education",
    year: "Sitakund Degree College (2014 - 2016) ",
    title: "HSC",
    desc: "After Completing my School life i have admitted in Sitakund College. College life was a great environment to enrich my outlook",
    rate: "4.42/5",
  },
  {
    id: 3,
    category: "education",
    year: "Masajidda High School (2012 - 2014) ",
    title: "SSC",
    desc: "After completing my Primary School life from S A Chowdhury Institute i admitted in Masajidda High School . The school was a great memory to make many curious and amicable friend zone",
    rate: "5.00/5 ",
  },
  {
    id: 4,
    category: "education",
    year: "Masajidda High School (2010 - 2011) ",
    title: "JSC",
    desc: "After completing my Primary School life from S A Chowdhury Institute i admitted in Masajidda High School . The school was a great memory to make many curious and amicable friend zone",
    rate: "4.86/5 ",
  },
  {
    id: 5,
    category: "experience",
    year: "Beyondtech (2024 - present) ",
    title: "Frontend Developer",
    desc: "The Purple algorithm is sister concern of Global Immigration Consultants Ltd. Here i am working with Frontend web technologies such as React JS, Next JS, Material UI, Tailwind CSS etc.",
    rate: "1 year",
  },
  {
    id: 6,
    category: "experience",
    year: "Dept of EEE, IIUC (2020 - 2023) ",
    title: "Teaching Assistant",
    desc: "I was teaching assistant of Department of Electrical and Electronic Engineering of International Islamic University. I was selected for my outstanding result in academic life",
    rate: "2 years",
  },
  {
    id: 7,
    category: "experience",
    year: "Land Mark Coaching Home (2018 - present) ",
    title: "ICT Instructor",
    desc: "I was ICT Instructor in Land Mark Coaching Home for a long time. Here I conducted Information and Communication Technology Course of A level. Number System, Web Design, C programming and Relational Database etc. was the main topic of this course",
    rate: "4 years",
  },
  {
    id: 8,
    category: "experience",
    year: "Central Library IIUC (2017 - 2018) ",
    title: "Data Entry Operator",
    desc: "I was data entry operator in Central Library of IIUC. This was my first Professional Job where my duty was to entry data of book in Khoha Software platform. I also maintained spreadsheet and Registry book",
    rate: "1 year",
  }
]

export default ResumeApi
